import httpClient from '../api/httpClient'
import { Maybe, fold } from '../lib'

export default {
  namespaced: true,

  state: {
    user: Maybe.None(),
    status: '',
    loading: false,
  },

  mutations: {
    setStatus(state, status) {
      state.status = status
    },

    setUser(state, user) {
      state.user = Maybe.Some(user)
    },

    setLoading(state, value) {
      state.loading = value
    },
  },

  getters: {
    isLoading: ({ loading }) => loading,
    isAdmin: ({ user }) =>
      fold(
        user,
        (user) => user?.admin === 1 || user?.admin === true,
        () => false,
      ),
    isLoggedIn: ({ user }) =>
      fold(
        user,
        () => true,
        () => false,
      ),
    loggedUser: ({ user }) =>
      fold(
        user,
        (user) => user,
        () => '',
      ),
  },

  actions: {
    async fetchUser({ commit }) {
      try {
        commit('setLoading', true)
        const response = await httpClient.get('/user/info')
        const { data } = response
        commit('setUser', data)
        commit('setLoading', false)
        return data
      } catch (err) {
        commit('setLoading', false)
        return null
      }
    },
    logout({ state }) {
      state.user = Maybe.None()
    },
  },
}
